import ResumeTwo from "./ResumeTwo";

export default ResumeTwo;
